import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SalaDetalleComponent } from './components/sala-detalle/sala-detalle.component';
import { CrearSalaComponent } from './components/crear-sala/crear-sala.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { SuperAdminComponent } from './components/superadmin/superadmin.component';
// Oculto temporalmente a pedido del usuario -- infraestructura de
// reembolsos lista y funcional (backend, componentes, guard), pendiente de
// una incorporación más exhaustiva antes de exponerla. Restaurar: quitar
// el comentario de este import y de las dos rutas de abajo, más las
// entradas equivalentes en admin-navigation.component.ts y
// superadmin.component.ts (buscar "Oculto temporalmente").
// import { RefundsComponent } from './components/refunds/refunds.component';
// import { PlatformRefundsComponent } from './components/platform-refunds/platform-refunds.component';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';
import { sceneGateGuard } from './guards/scene-gate.guard';
import { superAdminGuard } from './guards/super-admin.guard';
import { customersAccessGuard } from './guards/customers-access.guard';
import { spacesAccessGuard } from './guards/spaces-access.guard';
// import { reservationsAccessGuard } from './guards/reservations-access.guard';
export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // En login, guestGuard evita montar la vista si la sesión sigue vigente.
  // sceneGateGuard controla después la transición visual entre acceso y panel.
  { path: 'login', component: LoginComponent, canActivate: [guestGuard, sceneGateGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [sceneGateGuard, authGuard] },
  // Crear un espacio es un modal del dashboard; la ruta se conserva para
  // enlaces existentes y abre ese modal (con el mismo control de permiso).
  { path: 'crear-sala', component: CrearSalaComponent, canActivate: [sceneGateGuard, authGuard, spacesAccessGuard, () => inject(Router).parseUrl('/dashboard?module=salas&crear=1')] },
  { path: 'sala/:id', component: SalaDetalleComponent, canActivate: [sceneGateGuard, authGuard, spacesAccessGuard] },
  { path: 'usuarios', component: UsuariosComponent, canActivate: [sceneGateGuard, authGuard, customersAccessGuard] },
  { path: 'super-admin', component: SuperAdminComponent, canActivate: [sceneGateGuard, authGuard, superAdminGuard] },
  // { path: 'reembolsos', component: RefundsComponent, canActivate: [reservationsAccessGuard] },
  // { path: 'reembolsos-plataforma', component: PlatformRefundsComponent, canActivate: [superAdminGuard] },
  { path: '**', redirectTo: '/login' }
];
